var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errorMsgStatus
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger text-left",
            attrs: { role: "alert" }
          },
          [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMsgStatus
      ? _c(
          "div",
          {
            staticClass: "alert alert-success text-left",
            attrs: { role: "alert" }
          },
          [_c("span", [_vm._v(_vm._s(_vm.successMsg))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters mb-3 head-container" }, [
      _c("div", { staticClass: "col-12 col-md-6 display-1" }, [
        _vm._v(
          _vm._s(
            _vm.agencyData.agencyName ? _vm.agencyData.agencyName : "Agency"
          ) + " - Edit Details"
        )
      ]),
      _vm._v(" "),
      !_vm.activeTab3 && !_vm.activeTab4
        ? _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 mt-sm-2 mt-md-0 text-sm-left text-md-right"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: {
                    type: "button",
                    id: "edit-agency-cancel",
                    tabindex: "1"
                  },
                  on: { click: _vm.redirectToList }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-success",
                  attrs: { type: "button", tabindex: "1" },
                  on: { click: _vm.saveAgency }
                },
                [_vm._v("Save Changes")]
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2 mb-4" }, [
      _c("form", [
        _c(
          "div",
          [
            _c(
              "b-tabs",
              { attrs: { "content-class": "mt-3" } },
              [
                _c(
                  "b-tab",
                  {
                    attrs: { title: "Agency Details", active: _vm.activeTab1 },
                    on: {
                      click: function($event) {
                        return _vm.checkTabStatus(false, "am")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-12 col-md-6 mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "mr-md-4 pb-3 rounded shadow-sm" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-head py-2 px-3 rounded-top text-white"
                              },
                              [_vm._v("Agency Setup")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "float-right pr-3 mt-2 smaller-font-content"
                              },
                              [
                                _c("span", { staticClass: "star" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v("Required")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "px-3 my-2" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "agency_section0",
                                      "label-for": "agency_name"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c("label", [
                                        _vm._v("Agency Name"),
                                        _c("span", { staticClass: "star" }, [
                                          _vm._v("*")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true, min: 2 },
                                          expression:
                                            "{ required: true, min:2 }"
                                        }
                                      ],
                                      attrs: {
                                        id: "agency_name",
                                        name: "agency_name",
                                        disabled: !_vm.checkPermission(
                                          "CreateAgency"
                                        )
                                      },
                                      model: {
                                        value: _vm.agencyData.agencyName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.agencyData,
                                            "agencyName",
                                            $$v
                                          )
                                        },
                                        expression: "agencyData.agencyName"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-invalid-feedback",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "agency_name"
                                            ),
                                            expression:
                                              "errors.has('agency_name')"
                                          }
                                        ],
                                        attrs: { "force-show": true }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("agency_name")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "vendor-section" },
                                  [
                                    _c("input-select", {
                                      attrs: { fieldData: _vm.vendorOptionsArr }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "agency_section2",
                                      "label-for": "agency_SID"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c("label", [
                                        _vm._v("Agency SID"),
                                        _c("span", { staticClass: "star" }, [
                                          _vm._v("*")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{ required: true }"
                                        }
                                      ],
                                      attrs: {
                                        id: "agency_SID",
                                        name: "agency_SID",
                                        disabled: true,
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.agencyData.sid,
                                        callback: function($$v) {
                                          _vm.$set(_vm.agencyData, "sid", $$v)
                                        },
                                        expression: "agencyData.sid"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-invalid-feedback",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("agency_SID"),
                                            expression:
                                              "errors.has('agency_SID')"
                                          }
                                        ],
                                        attrs: { "force-show": true }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("agency_SID")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "vendor-section" },
                                  [
                                    _c("input-select", {
                                      attrs: { fieldData: _vm.appOptionsArr }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 mb-3 order-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-md-4 pb-3 rounded shadow-sm" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-head py-2 px-3 rounded-top text-white"
                                },
                                [_vm._v("Agency Settings")]
                              ),
                              _vm._v(" "),
                              _vm.preFillFlag
                                ? _c(
                                    "div",
                                    { staticClass: "px-3 my-2" },
                                    [
                                      this.productsArr.length > 0
                                        ? _c("PreFillProduct", {
                                            attrs: {
                                              product: _vm.productsArr,
                                              prefillConfig:
                                                _vm.agencyData.prefillConfig,
                                              preFillselectData:
                                                _vm.preFillselectArr
                                            },
                                            on: {
                                              isHomeReplacementCheck:
                                                _vm.isHomeReplacementCheck
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "px-3 my-2" },
                                [
                                  _c("input-number-custom", {
                                    attrs: { fieldData: _vm.fieldData }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 mb-3 order-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "ml-md-4 pb-3 rounded shadow-sm" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-head py-2 px-3 rounded-top text-white"
                                },
                                [_vm._v("Agency Details")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "px-3 py-2" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "agency_section3",
                                        label: "Phone Number",
                                        "label-for": "phone_number"
                                      }
                                    },
                                    [
                                      _c("the-mask", {
                                        class: {
                                          "form-control": true,
                                          error: _vm.errors.has("phone")
                                        },
                                        attrs: {
                                          name: "phone_number",
                                          id: "phone_number",
                                          type: "tel",
                                          placeholder: "XXX-XXX-XXXX",
                                          mask: "###-###-####"
                                        },
                                        model: {
                                          value: _vm.masked_input_value,
                                          callback: function($$v) {
                                            _vm.masked_input_value = $$v
                                          },
                                          expression: "masked_input_value"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "digits:10",
                                            expression: "'digits:10'"
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.masked_input_value,
                                            expression: "masked_input_value"
                                          }
                                        ],
                                        attrs: { name: "phone", type: "text" },
                                        domProps: {
                                          value: _vm.masked_input_value
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.masked_input_value =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has("phone"),
                                              expression: "errors.has('phone')"
                                            }
                                          ],
                                          attrs: { "force-show": true }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.errors.first("phone")
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "agency_section4",
                                        label: "Agency Address",
                                        "label-for": "agency_address"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "agency_address",
                                          name: "agency_address"
                                        },
                                        model: {
                                          value: _vm.agencyData.address,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.agencyData,
                                              "address",
                                              $$v
                                            )
                                          },
                                          expression: "agencyData.address"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "agency_section5",
                                        label: "City",
                                        "label-for": "agency_city"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "agency_city",
                                          name: "agency_city"
                                        },
                                        model: {
                                          value: _vm.agencyData.city,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.agencyData,
                                              "city",
                                              $$v
                                            )
                                          },
                                          expression: "agencyData.city"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 row" },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass:
                                            "mb-2 float-left mr-3 col-md-2 p-0",
                                          attrs: {
                                            id: "agency_section6",
                                            label: "State",
                                            "label-for": "agency_state"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "alpha",
                                                expression: "'alpha'"
                                              }
                                            ],
                                            staticClass: "col-md-10",
                                            attrs: {
                                              id: "agency_state",
                                              name: "agency_state",
                                              maxlength: "2"
                                            },
                                            model: {
                                              value: _vm.agencyData.state,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.agencyData,
                                                  "state",
                                                  $$v
                                                )
                                              },
                                              expression: "agencyData.state"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "agency_state"
                                                  ),
                                                  expression:
                                                    "errors.has('agency_state')"
                                                }
                                              ],
                                              attrs: { "force-show": true }
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "agency_state"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-2 float-left mr-3",
                                          attrs: {
                                            id: "agency_section7",
                                            label: "Zip Code",
                                            "label-for": "agency_zipcode"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "digits:5|length:5",
                                                expression:
                                                  "'digits:5|length:5'"
                                              }
                                            ],
                                            staticClass: "state-width",
                                            attrs: {
                                              id: "agency_zipcode",
                                              name: "agency_zipcode",
                                              type: "text",
                                              maxlength: "5"
                                            },
                                            model: {
                                              value: _vm.agencyData.zipCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.agencyData,
                                                  "zipCode",
                                                  $$v
                                                )
                                              },
                                              expression: "agencyData.zipCode"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "agency_zipcode"
                                                  ),
                                                  expression:
                                                    "errors.has('agency_zipcode')"
                                                }
                                              ],
                                              attrs: { "force-show": true }
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "agency_zipcode"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: "Appointed Carriers",
                      active: _vm.activeTab2
                    },
                    on: {
                      click: function($event) {
                        return _vm.checkTabStatus(true, "ap")
                      }
                    }
                  },
                  [
                    _vm.appointedCarrDataChk &&
                    _vm.currentProductAppointedCarriers !== null
                      ? [
                          _c("input-product-filter-appointed", {
                            attrs: {
                              emitToMethod: "onProductSwitch",
                              tabId: "ap",
                              defaultProduct: _vm.selectedProduct,
                              productAccessData: _vm.productAccessData
                            },
                            on: { onProductSwitch: _vm.onProductSwitch }
                          }),
                          _vm._v(" "),
                          _c("AppointedCarrier", {
                            attrs: {
                              appointedcarrierdata:
                                _vm.currentProductAppointedCarriers
                            }
                          })
                        ]
                      : _vm.currentProductAppointedCarriers === null
                      ? [
                          _c("div", { attrs: { id: "no-carriers-message" } }, [
                            _vm._v("No Carriers Available")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: { title: "Carrier Logins", active: _vm.activeTab3 },
                    on: {
                      click: function($event) {
                        return _vm.checkTabStatus(true, "cl")
                      }
                    }
                  },
                  [
                    _vm.currentProductAppointedCarriers !== null
                      ? [
                          _c("input-product-filter-appointed", {
                            attrs: {
                              emitToMethod: "onProductSwitch",
                              tabId: "cl",
                              defaultProduct: _vm.selectedProduct,
                              productAccessData: _vm.productOnlyAutoAccessData
                            },
                            on: { onProductSwitch: _vm.onProductSwitch }
                          }),
                          _vm._v(" "),
                          _c("CarrierCredentialUpdater", {
                            attrs: {
                              agencyID: this.$route.query.agencyID,
                              sId: this.agencyData.sid
                            },
                            on: {
                              CredentialSubmitStatus:
                                _vm.UpdateCredentialSubmit,
                              CredentialSubmitFailStatus:
                                _vm.UpdateCredentialFailSubmit
                            }
                          })
                        ]
                      : _vm.currentProductAppointedCarriers === null
                      ? [
                          _c("div", { attrs: { id: "no-carriers-message" } }, [
                            _vm._v("No Carriers Available")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: "EZLynx Templates",
                      active: _vm.activeTab4
                    },
                    on: {
                      click: function($event) {
                        return _vm.checkTabStatus(true, "ec")
                      }
                    }
                  },
                  [
                    _vm.currentProductAppointedCarriers !== null
                      ? [
                          _c("EzlynxTemplateLogin", {
                            attrs: { ezlynxcredential: _vm.ezlynxTemplateData },
                            on: {
                              EzlynxSubmitStatusFail:
                                _vm.UpdateEzlynxSubmitFail,
                              EzlynxSubmitStatus: _vm.UpdateEzlynxSubmit
                            }
                          })
                        ]
                      : _vm.currentProductAppointedCarriers === null
                      ? [
                          _c("div", { attrs: { id: "no-carriers-message" } }, [
                            _vm._v("No Carriers Available")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-009189ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-009189ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/EditAgency.vue
// module id = null
// module chunks = 